import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config, Pagination } from '../../../shared';
import { ConversationContainer } from '../../../../../../../models/mongodbSchema/aggregates';

@Injectable({ providedIn: 'root' })
export class ConversationService extends BaseApiTemplateService<ConversationContainer> {

  constructor(private http: HttpClient) {
    super();

      this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "conversations-resource"
      this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "conversations-resource"
      this.httpClient = http
  }

  public closeActiveSession(conversationUuid: String, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `/${conversationUuid}/session/close`;
    return this.httpClient.put<BasicApiResponseModel<ConversationContainer>>(
      url,
      {},
      this.getHttpHeader(apiVisa)
    );
  }

  public getConversationByTag(tag:String, apiVisa: ApiVisa, pagination: Pagination) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `/conversation-tags/filter/${tag}` + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<BasicApiResponseModel<ConversationContainer>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }

  public initiateHandover(payload, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `/handover`;
    return this.httpClient.post<BasicApiResponseModel<ConversationContainer>>(
      url,
      payload,
      this.getHttpHeader(apiVisa)
    );
  }

}
